import { render, staticRenderFns } from "./AddLanguageAction.vue?vue&type=template&id=12423f10&"
import script from "./AddLanguageAction.vue?vue&type=script&lang=js&"
export * from "./AddLanguageAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports